import React from "react"
import { KeyboardAvoidingView, Platform } from "react-native"
import { cn } from "../../styles/utils"

type AuthLayoutProps = {
  children: React.ReactNode
  className?: string
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({
  children,
  className,
}) => {
  return (
    <KeyboardAvoidingView
      behavior={Platform.OS === "ios" ? "padding" : "height"}
      className={cn(
        "flex-1 p-5 justify-center w-10/12 max-w-[600px] mx-auto",
        className,
      )}
    >
      {children}
    </KeyboardAvoidingView>
  )
}
